import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

export default function ThemeToggle({ className = "" }) {
  const { isDark, toggle } = useTheme();

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={isDark ? "Activar modo claro" : "Activar modo oscuro"}
      className={`relative inline-flex items-center justify-between w-14 h-7 rounded-full border border-line bg-page/60 backdrop-blur-md transition-colors hover:bg-sand ${className}`}
    >
      <span
        className={`absolute top-0.5 left-0.5 inline-flex items-center justify-center w-6 h-6 rounded-full bg-vino text-page shadow-sm transition-transform duration-300 ${
          isDark ? "translate-x-7" : "translate-x-0"
        }`}
      >
        {isDark ? <Moon size={13} /> : <Sun size={13} />}
      </span>
      <span className="sr-only">Cambiar tema</span>
    </button>
  );
}
